var startTarget = null;

function isNull(obj)
{
  return obj === null;
}

document.addEventListener("mousedown", function(e)
{
  startTarget = e.target;
});

document.addEventListener("click", function(e)
{
  var target = e.target;

  if(target.classList.contains("k-sidepanel") && target.classList.contains("k-sidepanel--active"))
  {
    if(startTarget != null && !startTarget.classList.contains("k-sidepanel"))
      return;

    target.classList.remove('k-sidepanel--active');
    document.body.classList.remove('js-sidepanel-active');

    return;
  }

  while(target && (target.tagName !== "BUTTON" && !(target.dataset && target.dataset.sidepanel)))
    target = target.parentNode;

  if(isNull(target))
    return;

  if(target.classList.contains("js-sidepanel-open"))
  {
      const sidepanels = document.querySelectorAll('.js-sidepanel');

      [...sidepanels].forEach((i) => {
        i.classList.remove('k-sidepanel--active');
      });

      const sidepanel = document.querySelector(target.dataset.sidepanel);

      sidepanel.classList.add('k-sidepanel--active');
      document.body.classList.add('js-sidepanel-active');

      if(sidepanel.dataset && sidepanel.dataset.url && navigator.clipboard)
        navigator.clipboard.writeText(sidepanel.dataset.url);
  }
  else if(target.classList.contains("js-row-sidepanel-open"))
  {
    if (window.matchMedia('(min-width: 1246px)').matches)
    {
      const sidepanels = document.querySelectorAll('.js-sidepanel');

      [...sidepanels].forEach((i) => {
        i.classList.remove('k-sidepanel--active');
      });

      const sidepanel = document.querySelector(target.dataset.sidepanel);

      sidepanel.classList.add('k-sidepanel--active');
      document.body.classList.add('js-sidepanel-active');
    }
  }
  else if(target.classList.contains("js-sidepanel-close-btn"))
  {
    const sidepanel = document.querySelector(target.dataset.sidepanel);
    sidepanel.classList.remove('k-sidepanel--active');
    document.body.classList.remove('js-sidepanel-active');
  }
});